import { render, staticRenderFns } from "./registersite.vue?vue&type=template&id=fbbce962&"
import script from "./registersite.vue?vue&type=script&lang=js&"
export * from "./registersite.vue?vue&type=script&lang=js&"
import style0 from "./registersite.vue?vue&type=style&index=0&id=fbbce962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports